<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow" 
			:dialog-class="''"
			:ok-title="'Search'"
			ok-variant="success" 
			:cancel-title="'Clear'" 
			@ok="getDownloadProcesss"
			@hidden="resetModal"
			>
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-job-id" label-cols-sm="4" label-cols-lg="3" label="Job ID" label-for="filter-job-id" size="sm" :model.sync="filter.jobId" />
					<app-input-textbox id="fieldset-function-id" label-cols-sm="4" label-cols-lg="3" label="Function ID" label-for="filter-function-id" size="sm" :model.sync="filter.functionId" />
					<app-input-textbox id="fieldset-file-name" label-cols-sm="4" label-cols-lg="3" label="File Name" label-for="filter-file-name" size="sm" :model.sync="filter.fileName" />
					<app-input-datetimepicker-range id="fieldset-start-time" label-cols-sm="4" label-cols-lg="3" label="Start Time" size="sm" :modelFrom.sync="filter.startTimeFrom" :modelTo.sync="filter.startTimeTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					<app-input-datetimepicker-range id="fieldset-end-time" label-cols-sm="4" label-cols-lg="3" label="End Time" size="sm" :modelFrom.sync="filter.endTimeFrom" :modelTo.sync="filter.endTimeTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					<app-input-textbox id="fieldset-status" label-cols-sm="4" label-cols-lg="3" label="Status" label-for="filter-status" size="sm" :model.sync="filter.status" />
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay
					:show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right"
					>
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>
		<b-row class="mb-2 d-sm-none d-md-flex">
			<b-col class="pt-1">
				<span class="function-title">Download Process</span>
			</b-col>
		</b-row>
		<div class="table-corner">
			<div class="table-action-button">
				<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
				<span class="d-inline d-md-none">
					<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
					<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
				</span>
				<span>
					<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
					<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
				</span>
			</div>
			<b-table :stacked="isStacked" id="table-list-downloadprocess" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="downloadProcesss" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
				<template #empty>
					<app-no-data-image />
				</template>
				<template #table-busy v-if="downloadProcesss.length <= 0">
					<app-no-data-image :animate="true" />
				</template>
				<template v-slot:head(front-action)>
					<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
				</template>
				<template v-slot:head(actions)>
					<b-button-group class="float-right"  size="sm">
					</b-button-group>
				</template>
				<template v-slot:head(filters)>
					<b-button-group class="float-left"  size="sm">
						<b-button @click="isShowFilter = !isShowFilter" size="sm"><b-icon-funnel-fill /></b-button>
					</b-button-group>
				</template>
				<template #top-row v-if="isShowFilter">
					<b-th></b-th>
					<b-th stacked-heading="Select All">
					</b-th>
					<b-th stacked-heading="Job ID">
						<b-form-input id="input-job-id-table" @input="getDownloadProcesssWithoutLoading" v-model="filter.jobId" size="sm"></b-form-input>
					</b-th>
					<b-th stacked-heading="Function ID">
						<b-form-input id="input-function-id-table" @input="getDownloadProcesssWithoutLoading" v-model="filter.functionId" size="sm"></b-form-input>
					</b-th>
					<b-th stacked-heading="File Name">
						<b-form-input id="input-file-name-table" @input="getDownloadProcesssWithoutLoading" v-model="filter.fileName" size="sm"></b-form-input>
					</b-th>
					<b-th stacked-heading="Start Time">
						<app-input-datetimepicker-range id="fieldset-start-time" label-cols-sm="4" label-cols-lg="3" :nolabel="true" label="Start Time" size="sm" :modelFrom.sync="filter.startTimeFrom" :modelTo.sync="filter.startTimeTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button  @change="getDownloadProcesssWithoutLoading" />
					</b-th>
					<b-th stacked-heading="End Time">
						<app-input-datetimepicker-range id="fieldset-end-time" label-cols-sm="4" label-cols-lg="3" :nolabel="true" label="End Time" size="sm" :modelFrom.sync="filter.endTimeFrom" :modelTo.sync="filter.endTimeTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button  @change="getDownloadProcesssWithoutLoading" />
					</b-th>
					<b-th stacked-heading="Status">
						<b-form-input id="input-status-table" @input="getDownloadProcesssWithoutLoading" v-model="filter.status" size="sm"></b-form-input>
					</b-th>
					<b-th stacked-heading="Error Message">
					</b-th>
				</template>
				<template v-slot:cell(no)="row">
					{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
				</template>
				<template v-slot:cell(startTime)="row">
					{{ row.item.startTime | moment("DD-MMM-YYYY HH:mm") }}
				</template>
				<template v-slot:cell(endTime)="row">
					{{ row.item.endTime | moment("DD-MMM-YYYY HH:mm") }}
				</template>
				<template v-slot:cell(actions)="row" >
					<div class="div-actions float-right">
					<b-button size="sm" v-if="false" :to="{path: '/downloadprocess/edit/' + row.item.id }" variant ="success"  class="mr-2 btn-xs">
						<b-icon-pencil></b-icon-pencil>
					</b-button>
					<b-overlay
						v-if="false"
						:show="busy"
						rounded
						opacity="0.6"
						spinner-small
						spinner-variant="primary"
						class="d-inline-block"
						>
						<click-confirm>
						<b-button size="sm" variant="danger" @click="deleteData(row.item.id)" class="mr-2 btn-xs">
							<b-icon-trash></b-icon-trash>
						</b-button>
						</click-confirm>
					</b-overlay>
					<b-button size="sm" v-if="(userRole != null ? userRole.allowRead : false)" variant="primary" class="mr-2 mt-md-2 mt-lg-0 btn-xs" :to="{path: '/downloadprocess/detail/' + row.item.id }" >
						<b-icon-eye-fill></b-icon-eye-fill>
					</b-button>
					<b-button size="sm" v-if="false" variant="light"  @click="printSingleData(row.item.id)" class="mr-2 mt-md-2 mt-lg-0 btn-xs">
						<b-icon-printer-fill></b-icon-printer-fill>
					</b-button>
					<b-overlay
						v-if="row.item.status == 'SUCCESS'"
						:show="isDownloadProcess"
						rounded
						opacity="0.6"
						spinner-small
						spinner-variant="primary"
						class="d-inline-block"
						>
					<b-button size="sm" variant="success"  @click="downloadFile(row.item)" class="mr-2 mt-md-2 mt-lg-0 btn-xs">
						<b-icon-download></b-icon-download>
					</b-button>
					</b-overlay>
					<b-form-checkbox v-if="false" class="d-inline" :id="'input-is-print-' + (row.index + 1)" @change="toggleIsPrint(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))" ></b-form-checkbox>
					</div>
				</template>
			</b-table>
		</div>
		<b-row>
			<b-col cols="12" class="paging-container">
				<div>
					<b-row>
						<b-col cols="12">
							<b-pagination
								class="btn-paging paging-page-size"
								v-model="currentPage"
								:total-rows="(downloadProcesssPaging != null ? downloadProcesssPaging.dataCount : 0)"
								:per-page="(downloadProcesssPaging != null ? downloadProcesssPaging.pageSize : 0)"
								aria-controls="my-table"
							>
								<template #first-text><b-icon-chevron-bar-left /></template>
								<template #prev-text><b-icon-chevron-left /></template>
								<template #next-text><b-icon-chevron-right /></template>
								<template #last-text><b-icon-chevron-bar-right /></template>
							</b-pagination>
							<span class="paging-page-size">
								<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
									<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
										{{ item.text }}
									</b-dropdown-item>
								</b-dropdown>
							</span>
						</b-col>
					</b-row>
				</div>
			</b-col>
		</b-row>
		<Upload
		:openPopup="showPopupUpload"
		@resetMethod="resetModalUpload"
		@uploadButtonMethod="uploadData"
		/>
		<PopupDownload
		:openPopup="showPopupDownload"
		:processId="processId"
		@resetModalMethod="resetModal"
		label= "Popup Download"
		:contentLabel = "popupDownloadLabel"
		/>
		<PopupPDF
		:openPopup="isShowPopupPDF"
		:pdfUrl="pdfUrl"
		@resetModalMethod="resetModal"
		label= "Popup PDF"
		/>
		
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';
</style>
<script>
import DownloadProcess from '@/models/DownloadProcess/DownloadProcess';
import DownloadProcessList from '@/models/DownloadProcess/DownloadProcessList';
import DownloadProcessFilter from '@/filters/DownloadProcess/DownloadProcessFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import AppInputTextarea from '@/components/AppInputTextarea';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components : {DownloadProcess, DownloadProcessList, DownloadProcessFilter, AppInputTextbox,AppInputDatetimepicker,AppInputDatetimepickerRange,AppInputTextarea,PopupDownload,PopupPDF,Upload,PopupDataEditNotification,},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}}, 
				{"jobId": {}, "class" : "th-job-id d-stack-none", "label" : "Job ID", key: 'jobId', sortable: true}, 
				{"functionId": {}, "class" : "th-function-id first-child", "label" : "Function ID", key: 'functionId', sortable: true}, 
				{"fileName": {}, "class" : "th-file-name d-stack-none", "label" : "File Name", key: 'fileName', sortable: true}, 
				{"startTime": {}, "class" : "th-start-time d-stack-none", "label" : "Start Time", key: 'startTime', sortable: true}, 
				{"endTime": {}, "class" : "th-end-time d-stack-none", "label" : "End Time", key: 'endTime', sortable: true}, 
				{"status": {}, "class" : "th-status last-child", "label" : "Status", key: 'status', sortable: true}, 
				{"errorMessage": {}, "class" : "th-error-message d-stack-none", "label" : "Error Message", key: 'errorMessage', sortable: true}, 
				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			downloadProcesss: [],
			downloadProcesssPaging: {},
			isDownloadProcess: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
		}
	},
	methods : {
		getDownloadProcesss : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			DownloadProcess.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.downloadProcesss = result.data
					this.downloadProcesssPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getDownloadProcesssWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			DownloadProcess.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.downloadProcesss = result.data
					this.downloadProcesssPaging = result
				}
			})
			.catch(error => {});
		},
		resetFilter() {
			this.filter = new DownloadProcessFilter();
			this.getDownloadProcesss();
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getDownloadProcesss();
		},
		toggleIsPrint(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				DownloadProcess.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
					this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			DownloadProcess.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			if (this.sortBy != null) {
					this.sortingBy[this.sortBy] = this.sortDesc;
			}
			this.isDownloadDataBusy = true;
			DownloadProcess.downloadData(this, this.filter, this.sortingBy).then(result => {
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			}).catch(error => { this.isDownloadDataBusy = false; })
		},
		deleteData(id) {
			DownloadProcess.deleteData(this, id).then(result => {
				if (result)
				{
					this.getDownloadProcesss();
				}
			})
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},
		async downloadFile(model) {
          	let this_ = this;
			this.isDownloadProcess = true;
		  	this.$http.get("downloadprocess/download/" + model.id).then(result => {
				console.log(result);
			  	let dataUrl = result.data.download;
				this_.$http.get(dataUrl, {responseType: 'blob'}).then(async response => {
					if (response != null) {
						await saveAs(response.data, model.fileName);
						this_.isDownloadProcess = false;
					}
					this_.isDownloadProcess = false;
				}).catch(error => {
					this_.$store.dispatch('addErrorMessageGlobal', error);
					this_.isDownloadProcess = false;
					throw error;
				});
		  	}).catch(error => {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				this_.isDownloadProcess = false;
				throw error;
			});
        },
		scrollRight() {
			var tableDownloadProcessParent = document.getElementById('table-list-downloadprocess').parentNode;
			tableDownloadProcessParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableDownloadProcessParent.scrollWidth - tableDownloadProcessParent.offsetWidth) == Math.ceil(tableDownloadProcessParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableDownloadProcessParent = document.getElementById('table-list-downloadprocess').parentNode;
			tableDownloadProcessParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableDownloadProcessParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new DownloadProcessFilter();
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Download Process"
		];
		this.getDownloadProcesss();
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
		});
	},
	watch: {
		sortBy: {
			handler: function() {
				this.getDownloadProcesss();
			}
		},
		sortDesc: {
			handler: function() {
				this.getDownloadProcesss();
			}
		},
		currentPage: {
			handler: function() {
				this.getDownloadProcesss();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getDownloadProcesss();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				DownloadProcess.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "downloadprocessindex") {
					this.getDownloadProcesssWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "download_process").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},
	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
